import { useEffect, useState } from 'react';
import Row from 'olive-react-myoneui/lib/Row';
import Col from 'olive-react-myoneui/lib/Col';
import Pagination from 'olive-react-myoneui/lib/Pagination';
import { setContentFilterData } from '../../../reducers/contentFilterSlice';
import { useDispatch } from 'react-redux';

const MykPagination = ({className, data}) => {
  const [currentPage, setCurrentPage] = useState(1); // To track the current page (1-based)
  
  const itemsPerPage = data.page_limit;
  
  const offset = (currentPage - 1) * itemsPerPage;
  const dispatch = useDispatch();
  dispatch(setContentFilterData({'offset': offset}));

  const totalPages = Math.ceil(data.total / itemsPerPage);

  // Handlers for previous and next buttons
  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const handlePageClick = (page) => {
    setCurrentPage(page);
  };

  return (
    <Row className={`${className || ''} myk__stu-pagination-wrapper`}>
      {data.total > 0 && (
      <Col>
        <div className="myk__stu-pagination-count">Showing <strong>{data.total > data.page_limit ? data.data.length : data.total}</strong> of <span className="total-items">{data.total}</span></div>
      </Col>
      )}
      <Col className="d-flex justify-content-end">
        <Pagination>
          {data.total > data.page_limit && (
            <Pagination.Prev onClick={handlePrev} disabled={currentPage === 1} />
          )}
          {data.total > data.page_limit && Array.from({ length: totalPages }, (_, i) => (
            <Pagination.Item key={i} active={currentPage === i + 1}
                onClick={() => handlePageClick(i + 1)}>{i + 1}</Pagination.Item>
          ))}
          {data.total > data.page_limit && (
            <Pagination.Next onClick={handleNext} disabled={currentPage === totalPages} />
          )}
        </Pagination>
      </Col>
    </Row>
  );
}

export default MykPagination;